import { render, staticRenderFns } from "./SymbolsGroup.vue?vue&type=template&id=f4f452e2&scoped=true"
import script from "./SymbolsGroup.vue?vue&type=script&lang=js"
export * from "./SymbolsGroup.vue?vue&type=script&lang=js"
import style0 from "./SymbolsGroup.vue?vue&type=style&index=0&id=f4f452e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f452e2",
  null
  
)

export default component.exports